export const BASE_URL = "https://admin.kryp.ai";
// const BASE_URL = 'http://localhost:3001'
// export {BASE_URL}
